import React from "react";

import MenuItem from "./MenuItems";
import { ReactComponent as HomeIcon } from "../../../assets/icons/HomeIcon.svg";
import { ReactComponent as SettingsIcon } from "../../../assets/icons/SettingsIcon.svg";
import { ReactComponent as LogoutIcon } from "../../../assets/icons/LogoutIcon.svg";

const BillingMenu = ({ path, handleLogout }) => {
  return (
    <div
      className="container-fluid  sidebar-menu-container"
      style={{ position: "relative", height: "65%" }}
    >
      <div style={{ height: "2vh" }} />
      <div
        style={{
          height: "50vh",
          overflowY: "scroll",
        }}
      >
        <MenuItem
          href={"/billing/"}
          text={"Dashboard"}
          selected={path.includes("billing")}
        >
          <HomeIcon />
        </MenuItem>
        <MenuItem
          icon={SettingsIcon}
          href={"/settings/change-password"}
          text={"Settings"}
          selected={path.includes("settings")}
        >
          <SettingsIcon />
        </MenuItem>
      </div>
      <hr style={{ color: "white", height: "2px", opacity: "100" }} />
      <div
        style={{
          position: "absolute",
          bottom: "2vh",
          width: "100%",
          padding: "0px",
          margin: "0px",
        }}
      >
        <MenuItem
          icon={LogoutIcon}
          onClick={handleLogout}
          href={""}
          text={"Logout"}
        >
          <LogoutIcon />
        </MenuItem>
      </div>
    </div>
  );
};

export default BillingMenu;
